import React from 'react';
import Picture from 'oldAssets/images/static_pages/our_mission/Andre_und_Matti.webp';
import Button from 'commonComponents/Button/Button';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import styles from './FromInvestors.module.scss';

const FromInvestors = ({ title, subtitle, text, button, link }) => {
  const headerProps = {
    title,
    subtitle,
    anchor: 'from-investors'
  };

  return ( 
    <section className={ styles.FromInvestors }>
      <div className={ styles.content }>
        <article>
          <SectionHeader { ...headerProps } />
          <div className={ styles.text }>
            { text && text.map((paragraph, i) => <p key={ i }>{ paragraph }</p>) }
          </div>
          <Button link={ link } label={ button } />
        </article>
        <figure>
          <img src={ Picture } />
        </figure>
      </div>
    </section>
  );
};
 
export default FromInvestors;